import { isNullOrUndefined } from '@adaptiva/core/common';
import { MasCveGapDetectionManagerService } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-cve-display-anchor',
	templateUrl: 'cve-display-anchor.component.html',
})
export class CveDisplayAnchorComponent {

	@Input()
	public set cves(_cves: string[] | string) {
		if (isNullOrUndefined(_cves)) 
			return;

		if (Array.isArray(_cves)) {
			if (_cves.length === 0)
				return;
			this.internalCves = _cves;
		} 
		else 
			this.internalCves =  [_cves];
	};

	public internalCves: string[];

	constructor(
		private _masGapDetectionManagerService: MasCveGapDetectionManagerService,
	) {
	}

	public openCveViewer(_cveId: string): void {
		this._masGapDetectionManagerService.viewCveInfo(_cveId);
	}
}
